// Every page outside /embed is served with `frame-ancestors 'self'`, so a
// widget that navigates in place strands the visitor in a fixed-height box with
// no chrome to go back with, and the browser refuses the document outright if
// that frame ever reloads. The embed leaves the frame instead.
// Returns false when the tab could not be opened, so the caller can say so.
export const openSitePage = (href: string) =>
  // No 'noopener': it makes window.open always return null, which is the only
  // signal a blocked pop-up gives. The target is our own origin.
  !!window.open(href, '_blank');

// Resolved before the check: a browser collapses `..` segments, so a raw prefix
// test would let `/embed/../classes` walk out of the widget routes.
export const isEmbedPath = (path: string) => {
  if (!path.startsWith('/') || path.startsWith('//')) return false;
  return new URL(path, 'http://embed').pathname.startsWith('/embed/');
};
